import CloseIcon from '../../assets/images/Icons/Close';
import DesignSystemButton from '../Button/DesignSystemButton';
import Modal from 'react-native-modal';
import React, { PropsWithChildren } from 'react';
import Show from '../Show/Show';
import { Body1Bold } from '../../config/designSystem/typography';
import { COLORS } from '../../config/designSystem/Colors';
import { DropShadowMedium } from '../DropShadows/DropShadowMedium';
import { SPACING } from '../../config/designSystem/Spacing';
import {  ScrollView, StyleProp, TouchableOpacity, View, ViewStyle } from 'react-native';

interface BasicModalWithButtonProps extends PropsWithChildren {
    isVisible: boolean;
    title: string;
    onDismiss: () => void;
    onPressButton: () => void;
    buttonText: string;
    buttonDisabled?: boolean;
    style?: StyleProp<ViewStyle>;
    /** once the closing animation is over: the moment another modal may open on iOS */
    onModalHide?: () => void;
  }

export const BasicModalWithButton = ({ children, isVisible,title, onDismiss, buttonDisabled, onPressButton,style, buttonText, onModalHide}: BasicModalWithButtonProps) => {
  const SIZE_ICON= SPACING['sp-24'];
  return (
    <Modal  isVisible={isVisible} onModalHide={onModalHide} style={[{flex:1, alignItems: 'center'}, style]}>
      <ScrollView contentContainerStyle={{
        borderRadius: SPACING['sp-16'],
        justifyContent: 'center',
        flexGrow: 1

      }}>

        <DropShadowMedium radius={SPACING['sp-16']}>
          <View style={{
            padding: SPACING['sp-24'],
            backgroundColor: COLORS.surface.primary, // Move background color here
            borderRadius: SPACING['sp-16']
          }}>
            <TouchableOpacity onPress={onDismiss}
              style={{zIndex: 1,top: SPACING['sp-12'], right: SPACING['sp-12'], position: 'absolute'}}>
              <CloseIcon  width={SIZE_ICON} height={SIZE_ICON} color={COLORS.content.accent}/>
            </TouchableOpacity>
            <View style={{rowGap: SPACING['sp-24'], marginTop: SPACING['sp-16']}}>
              <Body1Bold align={true}>{title}</Body1Bold>
              {children}
              <Show when={!buttonDisabled}>
                <View style={{alignSelf:'center', minWidth: '20%'}}>
                  <DesignSystemButton label={buttonText} onPress={onPressButton}/>
                </View>
              </Show>
            </View>
          </View>
        </DropShadowMedium>
      </ScrollView>
    </Modal>
  );
};